import { configureStore } from "@reduxjs/toolkit";

import networkReducer from "./networkListener";
// import studentReducer from "../features/manage_student_list/data/redux/reducer/ManageUserReducer";
// import AssessmentReducer from "../features/create_assessment/data/redux/reducer/AssessmentReducer";
import UserProfileReducer from "../features2/login/data/redux/LoginReducer";
// import FileReducer from "../features/manage_student_list/data/redux/reducer/UploadFileReducer";
// import QuestionFileReducer from "./../features/question_bank_list/data/redux/reducer/QuestionUploadFileReducer";
import programReducer from "./../features/calender/data/redux/reducer/ProgramDetailReducer";
import eventsReducer from "../../../src/app/features/calender/data/redux/reducer/eventReducer";
import assessmentReducer from "../features/assessment/data/redux/AssessmentSlice";
import dropDownReducer from "../features/recommendation/vedio-recommendation/data/redux/DropdownSLice";
import jozunaDropdown from "../features/recommendation/vedio-recommendation/data/redux/JozunaDropdown";
import popQuiz from "../features/recommendation/vedio-recommendation/data/redux/popQuizRedux";
import popQuizLogout from "../features/recommendation/vedio-recommendation/data/redux/QuizLogoutRedux";
import advancedFilterReducer from "../features/inventory_dashboard/data/redux/ProgramAdvanceFilterRedux";
import advancedFilterGradedPopQuizReducer from "../features/inventory_dashboard/data/redux/GradedPopQuizRedux";
import learningRoomReducer from "../features2/learning_room/data/redux/LearningRoomRedux";
const store = configureStore({
  reducer: {
    network: networkReducer,
    advancedFilter: advancedFilterReducer,
    advancedFilterGradedPopQuiz: advancedFilterGradedPopQuizReducer,
    // student: studentReducer,
    // assessment: AssessmentReducer,
    profile: UserProfileReducer,
    assessment: assessmentReducer,
    programs: programReducer,
    events: eventsReducer,
    dropdown: dropDownReducer,
    JozunaDropdown: jozunaDropdown,
    quizReducer: popQuiz,
    QuizLogout: popQuizLogout,
    learningRoom: learningRoomReducer,

    // File: FileReducer,
    // Questions: QuestionFileReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
